import { render } from "./Frame.vue?vue&type=template&id=71cb1de8"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"
script.render = render

export default script